module.exports = __webpack_public_path__ + "img/off.890ff10c.svg";